import React from "react";
import { Reveal } from "./Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { Butterfly } from "./Brand";

export const About = () => {
  const { t } = useLanguage();
  if (!t.about) return null;
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-32 md:py-44 bg-livon-bg overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="blob blob-lg" style={{ background: "radial-gradient(circle, #D8CEEA 0%, transparent 70%)", top: "5%", left: "-15%" }} />
        <div className="blob blob-lg" style={{ background: "radial-gradient(circle, #EFC9BC 0%, transparent 70%)", bottom: "-20%", right: "-10%" }} />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-center justify-center gap-3 mb-10" data-testid="about-label">
            <Butterfly size={28} />
            <span className="text-[11px] tracking-[0.35em] uppercase text-livon-muted font-medium">
              {t.about.label} · {t.about.eyebrow}
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.06}>
          <h2
            className="serif text-livon-ink text-center leading-[1.04] tracking-tight"
            style={{ fontSize: "clamp(2.5rem, 5.5vw, 5rem)", fontWeight: 500 }}
            data-testid="about-title"
          >
            {t.about.title}
          </h2>
        </Reveal>

        <div className="mt-14 md:mt-20 max-w-2xl mx-auto space-y-7 md:space-y-8">
          {t.about.paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.1 + i * 0.06}>
              <p
                data-testid={`about-p-${i}`}
                className="serif text-livon-ink leading-[1.45]"
                style={{ fontSize: "clamp(1.15rem, 1.5vw, 1.4rem)", fontWeight: 400 }}
              >
                {p}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.35}>
          <div className="mt-16 flex flex-col items-center">
            <div className="text-[11px] tracking-[0.4em] uppercase text-livon-muted font-medium" data-testid="about-signature">
              {t.about.signature}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
